import React, {useEffect, useRef, useState} from 'react';
import {IonButtons, IonHeader, IonPage} from '@ionic/react';
import {useTranslation} from 'react-i18next';
import {useHistory} from "react-router-dom";

import {log} from "@services/firebaseAnalytics.service";

import {StyledIonContent, StyledIonTitle, StyledIonToolbar} from '@components/content/content.style';
import {StyledHeaderButton, StyledHeaderButtonImage} from "@components/button/button.style";

import ArrowLeftImage from "@assets/images/arrow-left.svg";
import CarAddEditPane from "@app/travelAllowance/car/panes/carAddEditPane.component";

import {CarPaneType} from "@enums/travelAllowance/car";
import useLoadingOnViewChange from "@hooks/useLoadingOnViewChange";
import Pane from "@components/pane/pane.component";
import TravelAllowanceFormSkeleton from "@app/travelAllowance/common/components/travelAllowanceFormSkeleton.component";

const CarAddPage: React.FC = () => {
    const {t} = useTranslation();
    const history = useHistory();
    const pageLoading = useLoadingOnViewChange();

    const header = useRef<HTMLIonHeaderElement>(null);
    const [topEdge, updateTopEdge] = useState<number | undefined>(undefined);

    useEffect(() => {
        log('page_visit', {
            page: 'Samochody -> Dodaj'
        });

        updateHeight();
    }, []);

    const updateHeight = () => {
        if (header.current?.clientHeight === 0) {
            setTimeout(updateHeight);
        } else {
            updateTopEdge(header.current?.clientHeight);
        }
    };

    const handleBack = () => {
        history.goBack();
    };

    return (
        <IonPage>
            <StyledIonContent>
                <IonHeader ref={header} className="ion-no-border">
                    <StyledIonToolbar>
                        <IonButtons slot="start">
                            <StyledHeaderButton onClick={() => handleBack()}>
                                <StyledHeaderButtonImage src={ArrowLeftImage}></StyledHeaderButtonImage>
                            </StyledHeaderButton>
                        </IonButtons>
                        <StyledIonTitle>{t("carAddPage.title")}</StyledIonTitle>
                    </StyledIonToolbar>
                </IonHeader>
                {
                    pageLoading &&
                    <Pane topEdge={topEdge}>
                        <TravelAllowanceFormSkeleton/>
                    </Pane>
                }
                {
                    !pageLoading && <CarAddEditPane type={CarPaneType.ADD} topEdge={topEdge}/>
                }
            </StyledIonContent>
        </IonPage>
    );
};

export default CarAddPage;